import type { FeatureWebModule, WebModule, WebModulesRegistry } from './modules/core/index.js'
import type { AdminApi } from './admin/adminApi.js'
import { clientsWebModule } from './modules/clients/index.js'
import { accountsWebModule } from './modules/accounts/index.js'
import { auditWebModule } from './modules/audit/index.js'
import { facilitiesWebModule } from './modules/facilities/index.js'
import { rosterWebModule } from './modules/roster/index.js'
import { behaviorsWebModule } from './modules/behaviors/index.js'
import { partnerWebModule } from './modules/partner/index.js'
import { scheduleWebModule } from './modules/schedule/index.js'
import { scoringWebModule } from './modules/scoring/index.js'
import { messagesWebModule } from './modules/messages/index.js'
import { feedbackWebModule } from './modules/feedback/index.js'
import { systemWebModule } from './modules/system/index.js'
import { performanceReviewsWebModule } from './features/performance_reviews/definition.js'
import { executiveInsightsWebModule } from './features/executive_insights/definition.js'
import { aiBriefingsWebModule } from './features/ai_briefings/definition.js'

/**
 * The registry: the one place every module and every add-on is named, the
 * web's counterpart of the API's container (web modules plan phase 4). The
 * admin shell builds its menu from the modules' pages, in this order; the
 * other shells and the screens inside modules read the same list through
 * `WebModulesProvider`. Adding a domain is a folder under src/modules and a
 * line here; an add-on is a folder under src/features and a line here.
 */
export const MODULES: readonly WebModule<AdminApi>[] = [
  clientsWebModule,
  accountsWebModule,
  auditWebModule,
  facilitiesWebModule,
  rosterWebModule,
  behaviorsWebModule,
  partnerWebModule,
  scheduleWebModule,
  scoringWebModule,
  messagesWebModule,
  feedbackWebModule,
  systemWebModule,
]

/** Every add-on module, in catalog order. */
export const FEATURES: readonly FeatureWebModule[] = [performanceReviewsWebModule, executiveInsightsWebModule, aiBriefingsWebModule]

export const REGISTRY: WebModulesRegistry = { modules: MODULES, features: FEATURES }
